import { SVGProps } from 'react';

export default function BinaryTrainerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M28.7118 46.2538C38.6099 46.2538 46.7146 38.1534 46.7146 28.2537C46.7146 18.3541 38.6044 10.2538 28.7063 10.2538C18.8134 10.2538 10.7146 18.3541 10.7146 28.2537C10.7146 38.1534 18.8189 46.2538 28.7118 46.2538ZM26.885 36.7625C26.0308 36.7625 25.3498 36.3549 24.7668 35.6655L21.0328 31.2731C20.5675 30.729 20.4042 30.2763 20.4042 29.7153C20.4042 28.5108 21.3928 27.5679 22.5866 27.5679C23.2685 27.5679 23.783 27.8451 24.2615 28.3994L26.8627 31.4777L32.9609 21.8374C33.484 21.0157 34.0927 20.5967 34.8768 20.5967C36.0599 20.5967 37.1121 21.4703 37.1121 22.6698C37.1121 23.1218 36.958 23.6264 36.6128 24.1135L28.9447 35.6191C28.4513 36.3281 27.7029 36.7625 26.885 36.7625Z"
        fill="inherit"
      />
    </svg>
  );
}
